import { StarIcon } from 'lucide-react';

export function FilledStar() {
  return <StarIcon className="size-4 fill-yellow-400" strokeWidth={0} />;
}
